<template>
  <div class="row">
    <div class="col-lg-3 pl-1">
      <ListCompanyDivisions
        label=""
        name="divisionId"
        v-model="serverConfig.divisionId"
        placeholder="Division"
        small
        @input="onServerChange"
      />
    </div>
    <div class="col-lg-3 pl-1">
      <ListCompanyUnits
        label=""
        name="unitId"
        v-model="serverConfig.unitId"
        placeholder="Unidad"
        :parent-value="serverConfig.divisionId"
        small
        @input="onServerChange"
      />
    </div>
    <div class="col-lg-4 pl-1">
      <ListUser
        label=""
        name="targetUserId"
        small
        v-model="serverConfig.targetUserId"
        placeholder="Usuario"
        @input="onServerChange"
      />
    </div>
    <div class="col-lg-2 pl-1">
      <b-form-group class="mb-3">
        <b-form-input
          id="search"
          placeholder="Busqueda"
          name="search"
          size="sm"
          v-model="onTheFlyConfig.name"
          @input="onTheFlyChange"
        />
      </b-form-group>
    </div>
  </div>
</template>
<script>

import { FILTER_ON_THE_FLY_COMPARATORS, FILTER_SERVER_MAPPER } from '../config';

import ListCompanyDivisions from '@/febos/chile/lists/components/ListCompanyDivisions';
import ListCompanyUnits from '@/febos/chile/lists/components/ListCompanyUnits';
import ListUser from '@/febos/chile/lists/components/ListUser';

export default {
  data() {
    return {
      onTheFlyConfig: {
        name: ''
      },
      serverConfig: {
        divisionId: '',
        unitId: ''
      }
    };
  },
  methods: {
    onTheFlyChange() {
      const filters = Object.entries(this.onTheFlyConfig)
        .filter(([, value]) => !!value)
        .reduce((memo, [key, value]) => ({
          ...memo,
          [key]: FILTER_ON_THE_FLY_COMPARATORS[key](value)
        }), {});
      this.$emit('on-the-fly-filters-change', filters);
    },
    onServerChange() {
      const filters = Object.entries(this.serverConfig)
        .filter(([, value]) => !!value)
        .map(([key, value]) => (
          `${FILTER_SERVER_MAPPER[key]}:${value}`
        ))
        .join('|');
      this.$emit('on-server-filters-change', filters);
    }
  },
  components: {
    ListCompanyDivisions,
    ListCompanyUnits,
    ListUser
  }
};

</script>
